/**
 * @generated SignedSource<<ce8ade7860dd5ef61851d322bb5dab7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type walletPage_Query$variables = {
  perspectiveId?: string | null | undefined;
  slug: string;
};
export type walletPage_Query$data = {
  readonly sourcingAccounts: ReadonlyArray<{
    readonly keptSeparate: boolean;
    readonly merged: boolean;
    readonly name: string;
    readonly nearTwinCount: number;
    readonly qboId: string;
    readonly run: {
      readonly currentObject: string | null | undefined;
      readonly errorMessage: string | null | undefined;
      readonly jobId: number;
      readonly kind: string;
      readonly phase: string | null | undefined;
      readonly status: string;
    } | null | undefined;
    readonly suggestion: {
      readonly id: string;
      readonly nickname: string;
      readonly number: string;
    } | null | undefined;
  }>;
  readonly wallet: {
    readonly balance: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly bankAccount: {
      readonly id: string;
      readonly nickname: string;
      readonly number: string;
    } | null | undefined;
    readonly healthAlarms: ReadonlyArray<{
      readonly amount: number;
      readonly kind: string;
      readonly message: string;
      readonly period: string;
    }>;
    readonly inflows: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly name: string;
    readonly outflows: ReadonlyArray<{
      readonly month: string;
      readonly value: number | null | undefined;
    }>;
    readonly reconciliation: ReadonlyArray<{
      readonly date: string | null | undefined;
      readonly delta: number;
      readonly funded: number;
      readonly fundingMatched: boolean;
      readonly rec: string;
      readonly spent: number;
    }>;
    readonly shape: {
      readonly expected: string | null | undefined;
      readonly importedFirst: any | null | undefined;
      readonly importedLast: any | null | undefined;
      readonly importedTxns: number;
      readonly landedKind: string | null | undefined;
      readonly landedNumber: string | null | undefined;
      readonly message: string;
      readonly providers: string | null | undefined;
    } | null | undefined;
    readonly slug: string;
    readonly uploads: {
      readonly files: ReadonlyArray<{
        readonly filename: string | null | undefined;
      }>;
    };
  };
};
export type walletPage_Query = {
  response: walletPage_Query$data;
  variables: walletPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "number",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nickname",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccount",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "WalletReconciliationRow",
  "kind": "LinkedField",
  "name": "reconciliation",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rec",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "funded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "delta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fundingMatched",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landedKind",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landedNumber",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providers",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expected",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importedTxns",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importedFirst",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importedLast",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merged",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keptSeparate",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nearTwinCount",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "suggestion",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "run",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentObject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorMessage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "walletPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "balance",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "inflows",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "outflows",
            "plural": true,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletHealthAlarm",
            "kind": "LinkedField",
            "name": "healthAlarms",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletUploadsSummary",
            "kind": "LinkedField",
            "name": "uploads",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WalletUploadFile",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletShape",
            "kind": "LinkedField",
            "name": "shape",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingQboAccount",
        "kind": "LinkedField",
        "name": "sourcingAccounts",
        "plural": true,
        "selections": [
          (v24/*: any*/),
          (v4/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "walletPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "balance",
            "plural": true,
            "selections": (v30/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "inflows",
            "plural": true,
            "selections": (v30/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetricPoint",
            "kind": "LinkedField",
            "name": "outflows",
            "plural": true,
            "selections": (v30/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletHealthAlarm",
            "kind": "LinkedField",
            "name": "healthAlarms",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletUploadsSummary",
            "kind": "LinkedField",
            "name": "uploads",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WalletUploadFile",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletShape",
            "kind": "LinkedField",
            "name": "shape",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingQboAccount",
        "kind": "LinkedField",
        "name": "sourcingAccounts",
        "plural": true,
        "selections": [
          (v24/*: any*/),
          (v4/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dee408559f31c0e57061d6750e496a52",
    "id": null,
    "metadata": {},
    "name": "walletPage_Query",
    "operationKind": "query",
    "text": "query walletPage_Query(\n  $slug: String!\n  $perspectiveId: ID\n) {\n  wallet(slug: $slug, perspectiveId: $perspectiveId) {\n    slug\n    name\n    bankAccount {\n      id\n      number\n      nickname\n    }\n    balance {\n      month\n      value\n      id\n    }\n    inflows {\n      month\n      value\n      id\n    }\n    outflows {\n      month\n      value\n      id\n    }\n    healthAlarms {\n      kind\n      period\n      message\n      amount\n      id\n    }\n    reconciliation {\n      rec\n      date\n      funded\n      spent\n      delta\n      fundingMatched\n    }\n    uploads {\n      files {\n        filename\n        id\n      }\n      id\n    }\n    shape {\n      message\n      landedKind\n      landedNumber\n      providers\n      expected\n      importedTxns\n      importedFirst\n      importedLast\n      id\n    }\n    id\n  }\n  sourcingAccounts {\n    qboId\n    name\n    merged\n    keptSeparate\n    nearTwinCount\n    suggestion {\n      id\n      number\n      nickname\n    }\n    run {\n      jobId\n      kind\n      status\n      phase\n      currentObject\n      errorMessage\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9930213f08b0c19f85cbc1e0af1d5ce8";

export default node;
